module.exports = __webpack_public_path__ + "img/aiimage3.27897c8b.jpg";